import styled from 'styled-components';

export const Link = styled('a')`
  color: var(--secondary-text-color);
  &:hover {
    color: var(--tertiary-color-b);
  }
`
